import type { ReactNode } from 'react';
import Layout from './Layout';
import PageLayoutProvider from './provider';

export default function Page({ children }: { children: ReactNode }) {
  return (
    <PageLayoutProvider>
      <Layout>{children}</Layout>
    </PageLayoutProvider>
  );
}
